import React from "react";
import PageTitle from "../components/PageTitle";
import {Button, Image} from "antd";
import ReactFullpage from "@fullpage/react-fullpage";

import homeBackground from "../../pic/homeBackground.png"

import 'animate.css';

import home1 from "../../pic/home1.png";
import home2 from "../../pic/home2.png";
import home3 from "../../pic/home3.png";
import {Link} from "react-router-dom";

const Home=()=> {

    return <div
        className={'flex-c-n-fs-c wp100 roboto'}
    >
        <PageTitle currentPage={'Home'}/>
        <ReactFullpage
            //fullpage options
            sectionsColor={['#4f5299','white','#4f5299','white']}
            licenseKey = {'YOUR_KEY_HERE'}
            scrollingSpeed = {1000} /* Options here */
            navigation={true}
            loopTop={true}
            loopBottom={true}
            // autoScrolling={true}
            scrollHorizontally={true}
            color={['red','red','red','red']}
            render={({ state, fullpageApi }) => {
                return (
                    <ReactFullpage.Wrapper>
                        <div
                            className="section"
                        >
                            <img
                                className={'pos-ab wp90 t0 animate__animated animate__zoomIn'}
                                style={{
                                    top:'40px',
                                    left:'100px'
                                }}
                                loading="lazy"
                                src={homeBackground}
                            />
                                <div
                                    className={' wp100'}
                                    style={{
                                        overflowY:'hidden'
                                    }}
                                >
                                    <div
                                        className={'bold pos-re roboto italic fs64 center h50 mb40 animate__animated animate__fadeInUp font-white animate__delay-1s'}
                                    >
                                        TSCRE
                                    </div>
                                    <div
                                        className={'roboto fs34 bold mb20 center animate__animated animate__fadeInUp animate__delay-1s font-white'}
                                    >
                                        A comprehensive resource for <br/> <p className={'font-red inline'}>T</p>umor-<p className={'font-red inline'}>s</p>pecific <p className={'font-red inline'}>C</p>is-<p className={'font-red inline'}>R</p>egulatory <p className={'font-red inline'}>E</p>lements
                                    </div>
                                    <div
                                        className={' animate__animated animate__fadeInUp animate__delay-1s font-white'}
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        <Button
                                            type={'default'}
                                            shape={'default'}
                                            size={'large'}
                                            styles={{
                                                height:'40px'
                                            }}
                                            // block={true}
                                            // classNames={'fs25'}
                                        >
                                            <Link
                                                // target = "_blank"
                                                to={{
                                                    pathname:'/explorer',
                                                }}
                                            >
                                                <div
                                                    className={' fs22 lh22 bold font-main'}
                                                >
                                                    Get started
                                                </div>
                                            </Link>
                                        </Button>
                                    </div>
                                </div>
                        </div>
                        <div
                            className="section"
                        >
                            <div
                                className="flex-r-n-c-c wp100"
                            >
                                <div
                                    className={'wp50 flex-c-n-c-c roboto'}
                                >
                                    <div
                                        className={'fs44 bold roboto mb20'}
                                    >Welcome to
                                        <span
                                            className={'bold italic ml3 mr5'}
                                        >
                                            TSCRE
                                        </span>
                                        !
                                    </div>
                                    <div
                                        className={'fs25 bold wp80 text-justify roboto'}
                                        style={{
                                            fontSize:'1.5em'
                                        }}
                                    >
                                        <p className={'font-red inline italic'}>TSCRE</p> is a comprehensive catalog of human tumor-specific cis-regulatory elements (CREs) and super cis-regulatory elements (SCREs) derived from a re-analysis of public histone modification ChIP-seq data from 1,366 patient samples spanning 17 cancers. TSCRE enables the users to rapidly and intuitively explore dysregulated CRE/SCREs of interest in the context of different cancer types. In addition, TSCRE is also a powerful platform for querying relevant biological characteristics of CRE/SCREs based on multi-omics data.
                                    </div>
                                </div>
                                <div
                                    className={'wp40'}
                                >
                                    <Image
                                        loading="lazy"
                                        src={home1}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className="section"
                        >
                            <div
                                className="flex-r-n-c-c wp100"
                            >
                                <div
                                    className={'wp50 center'}
                                >
                                    <Image
                                        src={home2}
                                        width={'90%'}
                                        loading="lazy"
                                    />
                                </div>
                                <div
                                    className={'wp40 flex-c-n-c-c roboto font-white'}
                                >
                                    <div
                                        className={'fs40 bold mb15'}
                                    >
                                        What's in <span
                                        className={'bold italic mr8'}
                                    >
                                            TSCRE
                                        </span>
                                        ?
                                    </div>
                                    <div
                                        className={'fs22 bold text-justify'}
                                        style={{
                                            fontSize:'1.3em'
                                        }}
                                    >
                                        We explore the biological characteristics of CRE/SCREs through the following 4 aspects:
                                        <br/>1) Identify CRE/SCRE associated genes by Homer/ROSE programs along with “enhancer-to-promoter links” in ATAC-seq, Hi-C as well as Hi-ChIP; and investigate their mRNA expression in the matched tissues or cell lines.
                                        <br/>2) Explore the transcript factor (TF) binding sites and associated somatic mutations of individual CRE/SCRE.
                                        <br/>3) Determine the cancer-type specificity of individual CRE/SCRE by examing the pan-cancer chromatin accessibility and eRNA activity, along with the intersection with other CRE/SCREs.
                                        <br/>4) Investigate the enriched TFs and pathways using various analytical methods.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="section"
                        >
                            <div
                                className={'flex-c-n-fs-c wp100 roboto'}
                            >
                                <div
                                    className={'fs44 bold'}
                                >
                                    Data statistics
                                </div>
                                <div
                                    className={'fs22 bold mb20'}
                                    style={{
                                        fontSize:'1.5em'
                                    }}
                                >
                                    Currently, <span
                                    className={'bold italic mr5'}
                                >
                                            TSCRE
                                        </span>contains <p className={'font-red bold inline'}>1,864,941</p> dysregulated CREs and <p className={'font-red bold inline'}>68,253</p> dysregulated SCREs,<br/>derived from <p className={'font-red bold inline'}>1,366</p> patient samples spanning <p className={'font-red bold inline'}>17</p> cancer types and <p className={'font-red bold inline'}>9</p> histone markers.
                                </div>
                                <Image
                                    src={home3}
                                    // height={'25em'}
                                    width={'58%'}
                                    loading="lazy"
                                    // className={'wp70 mt30'}
                                />
                            </div>
                        </div>
                    </ReactFullpage.Wrapper>
                );
            }}
        />
    </div>
}
export default Home